module.exports = __webpack_public_path__ + "static/shang-yu_resume_20241228.e307c908.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/shang-yu_resume_20241228.pdf
// module id = 342
// module chunks = 213534597649335